import moment from 'moment'
import { InputHTMLAttributes, useCallback, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { IMaskInput } from 'react-imask'
import { INPUT_MASK } from '../../../../../../common/constants'
import {
  Checkbox,
  Input,
  InputProps,
  Select
} from '../../../../../../components/Form'
import {
  DatePickerCustom,
  DateProps
} from '../../../../../../components/Form/dateWithoutState'
import { ContainerAnimation } from './styles'
interface FormFormationProps extends InputHTMLAttributes<HTMLInputElement> {
  datepickerStartDate: DateProps
  datepickerEndDate: DateProps
  inputSchoolName: InputProps
  inputAddress: InputProps
  inputCourseStudy: InputProps
  label?: string
  positive?: InputProps
  negative?: InputProps
  data: any[]
  states: any[]
  setData: React.Dispatch<React.SetStateAction<any[]>>
  index?: number
  parent?: string
  hasHeader?: {
    label?: string
    positive?: InputProps
    negative?: InputProps
  }
  tooltip?: {
    type: string
  }
  changeTab?: React.SetStateAction<string>
}

export const FormFormation: React.FC<FormFormationProps> = ({
  datepickerStartDate,
  datepickerEndDate,
  inputSchoolName,
  inputCourseStudy,

  positive,
  negative,
  label,
  data,
  setData,
  index,

  hasHeader,
  changeTab,
  states
}) => {
  const {
    register,
    watch,
    setValue,
    getValues,
    formState: { errors },
    clearErrors,
    control
  } = useFormContext()
  const inputMaskFormat = 'DD/MM/YYYY'
  const watchShowField = hasHeader?.positive?.name
    ? watch(hasHeader?.positive?.name)
    : undefined
  const [copyData, setCopyData] = useState([...data])
  const [showInput, setShowInput] = useState(
    watchShowField || data[index]?.isActive || copyData[index]?.isActive || ''
  )
  const allowClass = ['show', 'show child']

  const handleAddForm = useCallback(
    (status: string) => {
      const showClass = ['show', 'show child']

      if (data[index + 1]) {
        const prefixArray = positive?.name.split('.')
        prefixArray.pop()
        const prefix = prefixArray.join('.')
        const workFields = getValues(prefix)
        if (workFields) {
          const objectEntries = Object.entries(workFields)
          for (let [key] of objectEntries) {
            key = `${prefix}.${key}`

            if (positive?.name !== key) {
              setValue(key, '')
            }
          }
        }
        clearErrors(prefix)
        setData(oldState => {
          const data = [...oldState]

          data[index + 1].isActive = showClass.includes(
            data[index + 1].isActive
          )
            ? 'hidden'
            : 'show'
          return data
        })
      } else {
        setData(oldState => {
          const data = [...oldState]
          data[index + 1] = {
            id: index + 1,
            isActive: showClass.includes(status) ? 'show child' : 'hidden',
            parent: index
          }
          data[index].isActive = 'show'
          return [...data]
        })
      }
    },
    [clearErrors, data, getValues, index, positive?.name, setData, setValue]
  )

  const handleClose = useCallback(() => {
    const showClass = ['show', 'show child']
    const watchField = watch(hasHeader?.positive?.name || '')
    if (watchField === 'hidden') {
      const prefixArray = hasHeader?.positive?.name.split('.')
      prefixArray.pop()
      const prefix = prefixArray.join('.')
      const workFields = getValues(prefix)
      if (workFields) {
        const objectEntries = Object.entries(workFields)
        for (let [key] of objectEntries) {
          key = `${prefix}.${key}`
          if (hasHeader?.positive?.name !== key) {
            setValue(key, '')
          }
        }
      }
      clearErrors(prefix)
    }
    if (showClass.includes(data[index]?.isActive)) {
      setData(oldState => {
        const data = [...oldState]
        data[index].isActive = showClass.includes(data[index].isActive)
          ? 'hidden'
          : 'show child'
        return data
      })
    }
  }, [
    clearErrors,
    data,
    getValues,
    hasHeader?.positive?.name,
    index,
    setData,
    setValue,
    watch
  ])

  return (
    <div className={'row '}>
      <div>
        {hasHeader?.label && (
          <p className="mb-2 form-check-label text-gray-700 fw-bold  p-0">
            {label}
          </p>
        )}
        <div className="d-flex">
          {hasHeader && hasHeader.positive && (
            <Checkbox
              className="col-xl-1"
              label="Sim"
              inputOptions={{
                classname: 'd-flex align-items-center'
              }}
              register={register}
              {...hasHeader.positive}
              errors={errors}
              type="radio"
              value="show"
              rules={{
                required: changeTab !== 'previous',
                onChange: () => {
                  const watchField = watch(hasHeader.positive.name)
                  if (watchField === 'show') {
                    setCopyData(oldState => {
                      const data = [...oldState]
                      data[index].isActive = 'show'
                      return [...data]
                    })
                    setShowInput('show')
                  } else {
                    handleClose()
                    setShowInput('hidden')
                  }
                }
              }}
              checked={allowClass.includes(showInput)}
              hasCustom
              hasErrorCustom
            />
          )}
          {hasHeader && hasHeader.negative && (
            <Checkbox
              className="col-xl-1"
              label="Não"
              inputOptions={{
                classname: 'd-flex align-items-center'
              }}
              {...hasHeader.negative}
              register={register}
              type="radio"
              value="hidden"
              rules={{ required: changeTab !== 'previous' }}
              errors={errors}
              checked={showInput === 'hidden'}
              hasCustom
            />
          )}
        </div>
      </div>
      <ContainerAnimation
        isShow={showInput}
        id={'Formation ' + datepickerStartDate.name}
        className="formation_container"
      >
        <div className="row mb-5 ">
          <Input
            className="col-xl "
            label="Nome da Instituição"
            register={register}
            inputOptions={{
              classname: 'd-flex align-items-center'
            }}
            {...inputSchoolName}
            rules={
              changeTab !== 'previous'
                ? {
                    required: allowClass.includes(showInput)
                  }
                : { required: false }
            }
            errors={errors}
            hasErrorCustom
            hasCustom
          />
        </div>
        <h3>Endereço completo</h3>

        <div className="row mb-5">
          <Controller
            shouldUnregister={true}
            control={control}
            name={'formations.' + index + '.address.zip_code'}
            rules={
              changeTab !== 'previous'
                ? {
                    required: allowClass.includes(showInput)
                  }
                : { required: false }
            }
            render={({ field }) => (
              <Input
                register={register}
                className="col-xl"
                label="CEP"
                inputOptions={{
                  classname: 'd-flex align-items-center'
                }}
                hasErrorCustom
                // name={formPrefix + '.' + "address.zip_code"}
                mask={{
                  mask: INPUT_MASK.ZIP_CODE,
                  type: 'zipCode',
                  prefixInputsData: 'formations.' + index + '.address.',
                  customFields: [
                    {
                      name: 'state',
                      type: 'state',
                      api_field: 'uf'
                    }
                  ]
                }}
                rules={
                  changeTab !== 'previous'
                    ? {
                        required: allowClass.includes(showInput)
                      }
                    : { required: false }
                }
                maxLength={10}
                hasCustom
                {...field}
                errors={errors}
              />
            )}
          />
        </div>
        <div className="row mb-5">
          <Input
            register={register}
            className="col-xl"
            label="Rua, nº, complemento"
            inputOptions={{
              classname: 'd-flex align-items-center'
            }}
            name={'formations.' + index + '.address.street'}
            rules={
              changeTab !== 'previous'
                ? {
                    required: allowClass.includes(showInput)
                  }
                : { required: false }
            }
            errors={errors}
            hasErrorCustom
            hasCustom
          />
        </div>
        {/* <div className="row mb-5">
          <Input
            register={register}
            className="col-xl"
            label="Número"
            inputOptions={{
              classname: 'd-flex align-items-center'
            }}
            name={'formations.' + index + '.address.number'}
            rules={
              changeTab !== 'previous'
                ? {
                    required: allowClass.includes(showInput)
                  }
                : { required: false }
            }
            hasErrorCustom
            hasCustom
            errors={errors}
          />
        </div> */}

        <div className="row mb-5">
          <Input
            register={register}
            className="col-xl"
            label="Cidade"
            inputOptions={{
              classname: 'd-flex align-items-center'
            }}
            name={'formations.' + index + '.address.city'}
            rules={
              changeTab !== 'previous'
                ? {
                    required: allowClass.includes(showInput)
                  }
                : { required: false }
            }
            hasErrorCustom
            hasCustom
            errors={errors}
          />
        </div>
        <div className="row mb-5">
          <Select
            className="col-xl"
            label="Estado"
            labelOptions={{ classname: 'col-xl' }}
            selectOptions={{
              classname: 'col-xl'
            }}
            name={'formations.' + index + '.address.state'}
            rules={
              changeTab !== 'previous'
                ? {
                    required: allowClass.includes(showInput)
                  }
                : { required: false }
            }
            options={states}
            register={register}
            blank
            errors={errors}
          />
        </div>
        <div className="row mb-5">
          <Input
            register={register}
            className="col-xl"
            label="Pais"
            inputOptions={{
              classname: 'd-flex align-items-center'
            }}
            name={'formations.' + index + '.address.country'}
            rules={
              changeTab !== 'previous'
                ? {
                    required: allowClass.includes(showInput)
                  }
                : { required: false }
            }
            errors={errors}
            hasErrorCustom
            hasCustom
          />
        </div>
        <div className="row mb-5 ">
          <Input
            className="col-xl "
            label="Curso de Estudo"
            register={register}
            inputOptions={{
              classname: 'd-flex align-items-center'
            }}
            {...inputCourseStudy}
            rules={
              changeTab !== 'previous'
                ? {
                    required: allowClass.includes(showInput)
                  }
                : { required: false }
            }
            errors={errors}
            hasErrorCustom
            hasCustom
          />
          <Controller
            shouldUnregister={true}
            name={datepickerStartDate.name}
            rules={
              changeTab !== 'previous'
                ? {
                    required: allowClass.includes(showInput)
                  }
                : { required: false }
            }
            render={({ field }) => (
              <DatePickerCustom
                popperProps={{ strategy: 'fixed' }}
                locale="ptBR"
                className="col-xl"
                register={register}
                inputOptions={{ classname: 'd-flex align-items-center' }}
                label="Data de início"
                dateFormat="dd/MM/yyyy"
                placeholderText="DD/MM/AAAA"
                hasCustom
                // selected={birthDate}
                {...field}
                errors={errors}
                hasErrorCustom
                maxDate={new Date()}
                customInput={
                  <IMaskInput
                    mask={Date}
                    pattern={'d/m/Y'}
                    format={date => {
                      return moment(date).format(inputMaskFormat)
                    }}
                    parse={value => {
                      return moment(value, inputMaskFormat).toDate()
                    }}
                  />
                }
                // onChange={(e: any) => {
                //   field.onChange(e)
                //   setBirthDate(e)
                // }}
              />
            )}
          />
          <Controller
            shouldUnregister={true}
            name={datepickerEndDate.name}
            rules={
              changeTab !== 'previous'
                ? {
                    required: allowClass.includes(showInput)
                  }
                : { required: false }
            }
            render={({ field }) => (
              <DatePickerCustom
                popperProps={{ strategy: 'fixed' }}
                locale="ptBR"
                className="col-xl"
                register={register}
                inputOptions={{ classname: 'd-flex align-items-center' }}
                label="Data de término"
                dateFormat="dd/MM/yyyy"
                placeholderText="DD/MM/AAAA"
                hasCustom
                // selected={birthDate}
                {...field}
                errors={errors}
                hasErrorCustom
                customInput={
                  <IMaskInput
                    mask={Date}
                    pattern={'d/m/Y'}
                    format={date => {
                      return moment(date).format(inputMaskFormat)
                    }}
                    parse={value => {
                      return moment(value, inputMaskFormat).toDate()
                    }}
                  />
                }
                // onChange={(e: any) => {
                //   field.onChange(e)
                //   setBirthDate(e)
                // }}
              />
            )}
          />
        </div>
        <div className="row mb-5 ">
          <p>Adicionar outra formação?</p>
          <div className="d-flex">
            <Checkbox
              className="col-xl-1"
              label="Sim "
              inputOptions={{
                classname: 'd-flex align-items-center'
              }}
              register={register}
              name={positive?.name}
              type="radio"
              value="show"
              rules={{
                onChange: () => {
                  const watchField = watch(positive.name)
                  if (watchField === 'show') {
                    handleAddForm('show')
                  } else {
                    handleAddForm('hidden')
                  }
                }
              }}
              checked={
                data[index + 1]?.isActive === 'show' ||
                data[index + 1]?.isActive === 'show child'
              }
              hasCustom
            />
            <Checkbox
              className="col-xl-1"
              label="Não"
              inputOptions={{
                classname: 'd-flex align-items-center'
              }}
              name={negative?.name}
              register={register}
              type="radio"
              value="hidden"
              checked={data[index + 1]?.isActive === 'hidden'}
              hasCustom
            />
          </div>
        </div>
      </ContainerAnimation>
    </div>
  )
}
